import { RenderViewComponentType } from '@upright/common/renderer/types';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { getEnvironment } from '../../../../common/environment';
import { getTextStyle } from '../../../common/generic/content/texts/bou-text/text-style';
import { BouColor } from '../../../common/generic/global/bou-colors';
import { BouSpacingLevel, fluidSpacing } from '../../../common/generic/layout/bou-spacing';
import { bouToolCommonBoxPadding } from '../../../common/generic/layout/layout-constants';
import { fluidSpaceLg } from '../../../common/generic/utilities/fluid/fluid';
import { useRenderViewContext } from '../context';
import { DevTools } from './dev-tools';
import { Dimensions } from './dimensions';
import { DownloadButton } from './download-button';
import { FileType } from './file-type';

export const RenderViewControls = (props: { componentControls: Array<ReactNode | undefined> }) => {
  const { componentControls } = props;
  const showDevTools = getEnvironment() === 'development';

  // OA A temporary hack to force png to Net Impact Lens due to pdf being borked.
  const hideFileTypeSelector = useRenderViewContext()
    .componentParams.map(d => d.componentType)
    .includes(RenderViewComponentType.LENS_NET_IMPACT);

  return (
    <Root>
      <ControlStrip>
        <ControlsWrap>
          <Dimensions />
          {!hideFileTypeSelector && <FileType />}
          {componentControls}
          {showDevTools && <DevTools />}
        </ControlsWrap>
        <Column>
          <DownloadButton />
        </Column>
      </ControlStrip>
      <PreviewText>Preview:</PreviewText>
    </Root>
  );
};

const Root = styled.div`
  ${getTextStyle({ size: 'xxs' })}
  ${fluidSpacing('margin-top', BouSpacingLevel.TINYISH)}
`;

const Column = styled.div`
  ${fluidSpaceLg('min-width', 150)}
  ${fluidSpacing('margin-right', BouSpacingLevel.SMALL)}
  ${fluidSpacing('margin-bottom', BouSpacingLevel.SMALL)}
`;

const ControlStrip = styled.div`
  ${bouToolCommonBoxPadding}
  border-bottom: 2px solid ${BouColor.TOOL_BORDER_DARK_GRAY};
`;

const ControlsWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
`;

const PreviewText = styled.div`
  ${bouToolCommonBoxPadding}
  margin-top: 12px;
`;
